'use client';

import { createPlatePlugin } from '@udecode/plate/react';

import { FixedToolbar } from '@/components/plate-ui/fixed-toolbar';
import { FixedToolbarButtons, FixedToolbarButtonsProps } from '@/components/plate-ui/fixed-toolbar-buttons';

export interface FixedToolbarPluginOptions {
  saveButton?: FixedToolbarButtonsProps['saveButton'];
}

export const createFixedToolbarPlugin = (options?: FixedToolbarPluginOptions) => {
  return createPlatePlugin({
    key: 'fixed-toolbar',
    render: {
      beforeEditable: () => (
        <FixedToolbar data-plate-fixed-toolbar>
          <FixedToolbarButtons saveButton={options?.saveButton} />
        </FixedToolbar>
      ),
    },
  });
};

// Default export for backward compatibility
export const FixedToolbarPlugin = createFixedToolbarPlugin();
